import axios from 'axios';
import { getCookie } from '../util/cookie';

const processPrefix = '/api/v1/application-process';
let store = null;

axios.interceptors.request.use(request => {
  store && store.dispatch('sessionExpiration/setSessionExpireDate', null);

  return request;
});

axios.interceptors.response.use(response => {
  store && store.dispatch('sessionExpiration/setSessionExpireDate', response.headers['session-expiry-datetime']);
  store && store.commit('auth/SET_AUTHENTICATED', getCookie('Authenticated') === 'true');

  return response;
});

// eslint-disable-next-line no-unused-vars
class LoanOriginationClient {
  static publicLogin(originalUrl, method, language) {
    const encoded = encodeURIComponent(originalUrl);
    window.location.href = `${window.location.origin}/auth/public-sso?originalUrl=${encoded}&method=${method}&language=${language}`;
  }

  static logout(language) {
    window.location.href = `${window.location.origin}/logout?language=${language}`;
  }

  static checkLoginServiceSso() {
    return axios.get(`${window.config.LOGIN_SERVICE_URL}/v2/login/check`, { withCredentials: true });
  }

  static checkSession() {
    return axios.get(`${window.location.origin}/api/v1/session`);
  }

  static logoutSsoSession(language) {
    window.location.href = `${window.config.LOGIN_SERVICE_URL}/logout?language=${language}`;
  }

  static showSessionExpiredPage() {
    window.location.href = `${window.location.origin}/session-expired`;
  }

  static getProducts(body) {
    return axios.post('/api/v2/pricing-conditions', body);
  }

  static calculateLoanDetails(body) {
    return axios.post(`/api/v1/loan/calculate`, body);
  }

  static createUpsaleApplication(body) {
    return axios.post(`${processPrefix}/upsale`, body);
  }

  static createApplication(body, hCaptchaToken) {
    return axios.post(processPrefix, body, { headers: { 'X-hCaptcha-token': hCaptchaToken }});
  }

  static updateProcessStep(id, body) {
    return axios.post(`${processPrefix}/${id}/step`, body);
  }

  static continueProcess(id, role) {
    const params = roleQuery(role);

    return axios.post(`${processPrefix}/${id}/continue`, {}, { params });
  }

  static updateApplication(id, body) {
    return axios.put(`${processPrefix}/${id}/step`, body);
  }

  static uploadDocument(id, formData) {
    return axios.post(`${processPrefix}/${id}/document`, formData);
  }

  static annulApplication(id, body) {
    return axios.post(`${processPrefix}/${id}/annul`, body);
  }

  static getUnsignedContractDetails(id) {
    return axios.get(`/api/v2/application/${id}/contract/default/unsigned/details`);
  }

  static extendSession() {
    return axios.get('/api/v1/session/extend');
  }

  static heartbeat() {
    return axios.get('/api/session/heartbeat');
  }

  static syncStore(appStore) {
    store = appStore;
  }

  static initiateSigning(id, body) {
    return axios.post(`/api/v1/application/${id}/signing`, body);
  }

  static getSigningStatus(id, body) {
    return axios.post(`/api/v1/application/${id}/signing/status`, body);
  }

  static getActiveApplications(canBeRelatedPerson) {
    return axios.post(`/api/v1/active-applications`, { canBeRelatedPerson });
  }

  static annulActiveApplications() {
    return axios.post(`/api/v1/active-applications/annul`);
  }
}

const roleQuery = role => {
  const params = new URLSearchParams();
  // Avoid undefined or empty role
  if (typeof role !== 'undefined' && role !== '') {
    params.append('role', role);
  }

  return params;
};

export default LoanOriginationClient;
